
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.25","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M15.59 9.375v8.75s-1.25 1.25-5.624 1.25c-4.375 0-5.625-1.25-5.625-1.25v-8.75"}}),_c('path',{attrs:{"d":"M5.59 1.875l-1.514.65a4.998 4.998 0 00-3.027 4.333l-.423 8.11a.624.624 0 00.59.656l.034.001h3.09m11.25 0h3.092a.624.624 0 00.625-.623l-.001-.035-.423-8.11a5 5 0 00-3.024-4.333l-1.518-.649m-.001 0a2.5 2.5 0 01-2.5 2.5H8.09a2.5 2.5 0 01-2.5-2.5c0-.69.56-1.25 1.25-1.25h6.25c.69 0 1.25.56 1.25 1.25zm-6.25 2.5v2.5m3.75-2.5v5"}})])])
          )
        }
      }
    